import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { orderTags } from 'src/app/shared/const/orders';
import { appState } from 'src/app/shared/interfaces/appState.interface';
import { OrderValidator } from 'src/app/shared/order';
import { Field } from '../fields.component';
import { broker, BROKERS_CONST } from '@shared-logic/subjects';
import { setOrderToGenerate } from 'src/app/redux/actions/order.action';

@Component({
  selector: 'app-broker',
  templateUrl: './broker.component.html',
  styleUrls: ['./../fields.component.scss']
})
export class BrokerComponent extends Field implements OnInit, OnDestroy {
  @Input() showOtherOption: boolean = false;
  BROKERS = broker;
  BROKERS_CONST = BROKERS_CONST;
  isGrassi: boolean = true;
  validsBroker: any[] = [];
  brokerSelected = 1;

  private orderSubscriptionAux!: Subscription;
  constructor(store: Store<appState>, private orderV: OrderValidator) {
    super(store);
    this.orderSubscriptionAux = this.store.select('order').subscribe(order => {
      this.getBrokersValid();
    });
  }

  ngOnInit(): void {
    this.tag = orderTags.broke;
    this.setIdentifyClassName();
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.orderSubscriptionAux.unsubscribe();
  }

  override setElement(element: any, index: number) {
    this.brokerSelected = element;
    this.setElementToGenerate(Number(element));
  }

  override rememberValueInForm() {
    this.rememberValueWithObject();
    const value = this.rememberValue();
    if (value > 0) {
      this.brokerSelected = value;
    }
  }

  setIsGrassi(boolean: boolean) {
    if (this.validsBroker.includes(boolean ? BROKERS_CONST.GRASSI : BROKERS_CONST.GGSA_1888)) {
      this.isGrassi = boolean;
      const valueToSet = this.isGrassi ? BROKERS_CONST.GRASSI : BROKERS_CONST.GGSA_1888;
      this.setElement(valueToSet, 0);

      // Limpiamos la corredora del vendedor si no es "Otro"
      let newOrder = JSON.parse(JSON.stringify(this.elementToGenerate));
      if (newOrder.sellerData) {
        newOrder.sellerData.broker = null;
      }
      this.store.dispatch(setOrderToGenerate({
        order: newOrder,
        tag: 'sellerData',
        subTag: 'broker'
      }));
    }
  }

  setIsGrassiEvent(boolean: boolean, event: any) {
    const isEnter = event.key.toLowerCase() == 'enter';
    if (isEnter) {
      this.setIsGrassi(boolean);
    }
  }

  setOtroBroker() {
    this.brokerSelected = BROKERS_CONST.BROKER_OTRO;
    this.setElement(BROKERS_CONST.BROKER_OTRO, 0);
  }

  private timeoutId: any;

  getBrokersValid() {
    if (this.elementToGenerate && this.elementToGenerate.placeOfOrigin.province > 0) {
      this.validsBroker = this.orderV.getBrokersByProvince(this.elementToGenerate.placeOfOrigin.province);

      const currentBroker = this.elementToGenerate.broke;

      // Si ya es "Otro" o un corredor válido para la provincia, no hacemos nada automático
      if (currentBroker === BROKERS_CONST.BROKER_OTRO || 
          (currentBroker > 0 && this.validsBroker.includes(currentBroker))) {
        if (this.timeoutId) clearTimeout(this.timeoutId);
        return;
      }

      // Evitamos disparar múltiples timeouts si el estado cambia rápidamente
      if (this.timeoutId) clearTimeout(this.timeoutId);

      this.timeoutId = setTimeout(() => {
        const broker = this.elementToGenerate?.broke;

        // Doble chequeo dentro del timeout
        if (broker === BROKERS_CONST.BROKER_OTRO || 
            (broker > 0 && this.validsBroker.includes(broker))) {
          return;
        }

        if (broker <= 0 || !this.validsBroker.includes(broker)) {
          if (this.validsBroker.length > 0) {
            // Seteamos el primero de la lista de válidos por defecto
            this.setIsGrassi(this.validsBroker[0] == BROKERS_CONST.GRASSI);
          } else {
            this.setElement(-1, 0);
          }
        }
      }, 500);
    }
  }

  getIsInvalid() {
    // Si se seleccionó "Otro", la validación de provincia no aplica
    if (this.elementToGenerate?.broke === BROKERS_CONST.BROKER_OTRO) return false;
    return this.validsBroker?.length == 0 && this.elementToGenerate?.broke <= 0;
  }
}
